import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: 56.25%;

  .responsive-iframe-desktop {
    display: initial;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  .responsive-iframe-mobile {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  @media only screen and (max-width: 768px) {
    height: 100vh;

    .responsive-iframe-desktop {
      display: none !important;
    }
    .responsive-iframe-mobile {
      display: initial !important;
    }
  }
`;
